<template>
    <div
        v-loading="loading"
        class="py-5">
        <div
            v-if="editable"
            class="mb-2">
            <div class="mb-3 text-right">
                <hts-form-button
                    icon-name="hi-plus-circle-icon"
                    icon-position="right"
                    size="small"
                    color="primary"
                    type="submit"
                    @click="addDocument">
                    {{ $t('labels.addDocument') }}
                </hts-form-button>
            </div>
        </div>
        <div v-if="list.length">
            <!-- Header Desktop -->
            <div class="hidden md:grid grid-cols-6 gap-2 p-2 font-medium border-b bg-gray-100">
                <div>
                    Tên file
                </div>
                <div>
                    Ngày tạo
                </div>
                <div>
                    Tác vụ
                </div>
                <div>
                    Tạo bởi
                </div>
                <div>
                    Xem file
                </div>
                <div>
                    Hành động
                </div>
            </div>

            <!-- Content -->
            <template
                v-for="(file, index) in list"
                :key="index">
                <!-- Desktop Row -->
                <div class="hidden md:grid grid-cols-6 gap-2 p-2 border-b items-center">
                    <div class="truncate">
                        <hts-tooltip reference-class="truncate">
                            <span>
                                {{ file.originalName || file.fileOriginName || file.fileName }}
                            </span>
                            <template #reference>
                                <span class="truncate">
                                    {{ file.originalName || file.fileOriginName || file.fileName }}
                                </span>
                            </template>
                        </hts-tooltip>
                    </div>
                    <div>
                        {{ $formatters.datetime(file.createdAt) }}
                    </div>
                    <div>
                        {{ file.taskName || 'Khác' }}
                    </div>
                    <div>
                        <hts-user
                            :id="file.createdBy"
                            inline
                            size="mini" />
                    </div>
                    <div>
                        <a
                            :href="$formatters.cdnUrl(file.path)"
                            target="_blank">
                            <img
                                v-if="file.mimeType && file.mimeType.includes('image')"
                                :src="$formatters.cdnUrl(file.path)"
                                class="max-h-20 max-w-full shadow border rounded" >
                            <span
                                v-else
                                class="underline text-blue-500">
                                Mở file
                            </span>
                        </a>
                    </div>
                    <div class="flex gap-2">
                        <button
                            class="text-blue-500 hover:text-blue-800"
                            @click="editFile(file)">
                            <hi-pencil-icon class="h-5 w-5" />
                        </button>

                        <button
                            class="text-blue-500 hover:text-blue-800"
                            @click="downloadFile(file)">
                            <hi-arrow-down-tray-icon class="h-5 w-5" />
                        </button>

                        <button
                            class="text-red-600 hover:text-red-800"
                            @click="deleteFile(file)">
                            <hi-trash-icon class="h-5 w-5" />
                        </button>
                    </div>
                </div>

                <!-- Mobile Card -->
                <div class="block md:hidden p-3 border rounded shadow mt-2 space-y-2">
                    <div>
                        <span class="font-semibold">
                            Tên file:
                        </span>
                        <span>
                            {{ file.originalName || file.fileOriginName || file.fileName }}
                        </span>
                    </div>
                    <div>
                        <span class="font-semibold">
                            Ngày tạo:
                        </span>
                        {{ $formatters.datetime(file.createdAt) }}
                    </div>
                    <div>
                        <span class="font-semibold">
                            Tác vụ:
                        </span>
                        {{ file.taskName || 'Khác' }}
                    </div>
                    <div>
                        <span class="font-semibold">
                            Tạo bởi:
                        </span>
                        <hts-user
                            :id="file.createdBy"
                            inline
                            size="mini" />
                    </div>
                    <div>
                        <a
                            :href="file.url"
                            target="_blank">
                            <img
                                v-if="file.mimeType && file.mimeType.includes('image')"
                                :src="file.url"
                                class="max-h-20 max-w-full shadow border rounded" >
                            <span
                                v-else
                                class="underline text-blue-500">
                                Mở file
                            </span>
                        </a>
                    </div>
                    <div class="flex gap-4 pt-2 border-t mt-2">
                        <button
                            class="text-blue-500 hover:text-blue-800 flex items-center gap-1"
                            @click="editFile(file)">
                            <hi-pencil-icon class="h-5 w-5" /> <span>
                                Sửa
                            </span>
                        </button>

                        <button
                            class="text-blue-500 hover:text-blue-800 flex items-center gap-1"
                            @click="downloadFile(file)">
                            <hi-arrow-down-tray-icon class="h-5 w-5" /><span>
                                Tải về
                            </span>
                        </button>

                        <button
                            class="text-red-600 hover:text-red-800 flex items-center gap-1"
                            @click="deleteFile(file)">
                            <hi-trash-icon class="h-5 w-5" /><span>
                                Xóa
                            </span>
                        </button>
                    </div>
                </div>
            </template>
        </div>

        <div v-else>
            Chưa có tài liệu
        </div>

        <hts-modal
            :show="showModalAdd"
            title="Thêm tài liệu"
            @hide="showModalAdd = false">
            <hts-form
                class="mt-5"
                @submit="handleAddDocument">
                <!--
                  v-for="(data, index) in formAdd"
                  :key="index"
                -->
                <div class="flex gap-3">
                    <hts-form-select
                        v-model="formAdd.task"
                        :label="$t('labels.task')"
                        :items="taskOptions || []"
                        required
                        key-id="key"
                        key-label="label"
                        name="task"
                        class="w-full"
                        prop="task" />

                    <hts-form-file
                        ref="file"
                        v-model="formAdd.files"
                        required
                        type="file"
                        multiple
                        name="document"
                        prop="document"
                        :label="$t('labels.document')"
                        class="w-full" />

                    <!--
                      <div class="w-8">
                      <hi-x-circle-icon
                      class="h-6 w-6 mt-8 text-error-500 hover:text-error-700 cursor-pointer"
                      @click="($event: any )=> deleteLineDocument($event, index)" />
                      </div>
                    -->
                </div>

                <!--
                  <hts-form-button
                  icon-name="hi-check-icon"
                  icon-position="right"
                  type="button"
                  color="info"
                  size="small"
                  @click="addLineDocument">
                  Thêm tài liệu
                  </hts-form-button>
                -->

                <div class="flex justify-end mt-5 gap-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        type="submit"
                        color="info"
                        :outline="false">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>

        <hts-modal
            :show="showModalEdit"
            title="Chỉnh sữa tài liệu"
            @hide="showModalEdit = false">
            <hts-form-input
                v-model="formEdit.fileName"
                :label="$t('labels.fileName')" />

            <div class="flex justify-end mt-5 gap-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    type="button"
                    color="primary"
                    @click="handleEditFile">
                    {{ $t('labels.save') }}
                </hts-form-button>
            </div>
        </hts-modal>

        <hts-modal
            :show="showModalDelete"
            title="Xóa tài liệu"
            type="confirm"
            @hide="showModalDelete = false"
            @confirm="handleDeleteFile">
            <p>
                Bạn có chắc muốn xoá tài liệu
                <span class="font-bold">
                    {{ formEdit.fileName }}
                </span>? Tất cả thông tin sẽ bị mất và không thể quay lại
            </p>
        </hts-modal>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  journeyId: {
    type: String as PropType<string | null>,
    required: true
  },
  editable: Boolean
})

const { journeyId } = toRefs(props)
const loading = ref(false)
const loadingEdit = ref<boolean>(false)
const loadingDelete = ref<boolean>(false)

const list = ref<any[]>([])
const uploadFile = ref()

const fileSelected = ref<any>(null)
const showModalEdit = ref<boolean>(false)
const showModalDelete = ref<boolean>(false)
const showModalAdd = ref<boolean>(false)
const taskOptions = ref([])
const formEdit = ref({
  fileName: ''
})

const formAdd = ref({
  task: '',
  files: null
})

const getFiles = () => {
  if (!journeyId.value) {
    return
  }
  list.value = []
  loading.value = true
  $api($url.monitoring.journey.file.get, { uriParams: { ID: journeyId.value } }).then(({ data }: any) => {
    list.value = (data?.value || {}).data || []
    loading.value = false
  })
}
const openUpload = () => {
  if (uploadFile.value) {
    uploadFile.value.open()
  }
}

const addDocument = () => {
  $api($url.monitoring.journey.file.taskOptions, {
    uriParams: { ID: journeyId.value }
  })
    .then((response: any) => {
      const { data, success, errors } = response.data?.value || {}

      if (success) {
        showModalAdd.value = true
        taskOptions.value = data
        formAdd.value.task = ''
        formAdd.value.files = null
      }

      loadingEdit.value = false
    })
    .catch(() => {
      loadingEdit.value = false
    })
}

const handleAddDocument = () => {
  const data = prepareFormData()

  $api($url.monitoring.journey.file.upload, {
    uriParams: { ID: journeyId.value },
    body: data
  })
    .then((response: any) => {
      const { data, success, errors } = response.data?.value || {}

      if (success) {
        process.client && $toast().success($t('labels.addSuccess'))
        refresh()
        showModalAdd.value = false
      }

      loadingEdit.value = false
    })
    .catch(() => {
      loadingEdit.value = false
    })
}

const prepareFormData = () => {
  const formData = new FormData()

  const task: any = taskOptions.value.find((data: any) => data.key === formAdd.value.task)

  formData.append(`positionId`, task.positionId || '')
  formData.append(`indexTask`, task.indexTask || '')
  formData.append(`travelStageIndex`, task.travelStageIndex || '')
  formData.append(`travelIndex`, task.travelIndex || '')
  if (formAdd.value.files) {
    // Nếu là FileList thì chuyển thành mảng
    const filesArray = Array.from(formAdd.value.files)
    filesArray.forEach((file: any, fileIndex: number) => {
      formData.append(`files`, file)
    })
  }

  return formData
}

const addLineDocument = () => {
  // formAdd.value.push({
  //   task: '',
  //   files: null
  // })
}

const deleteLineDocument = (e: Event, index: number) => {
  e.preventDefault()
  e.stopPropagation()

  // if (!formAdd.value[index]) {
  //   return
  // }
  // formAdd.value.splice(index, 1)
}

const editFile = (file: any) => {
  if (!file) {
    return
  }
  formEdit.value.fileName = file.originalName || file.fileOriginName || file.fileName
  fileSelected.value = file
  showModalEdit.value = true
}

const downloadFile = async (file: any) => {
  if (!file || !file.url) {
    return
  }

  const name = file.originalName || file.fileOriginName || file.fileName || 'downloaded_file'

  try {
    const response = await fetch(file.url)
    const blob = await response.blob()
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Download failed:', error)
  }
}

const deleteFile = (file: any) => {
  if (!file) {
    return
  }
  formEdit.value.fileName = file.originalName || file.fileOriginName || file.fileName
  fileSelected.value = file
  showModalDelete.value = true
}

const handleEditFile = () => {
  loadingEdit.value = true
  $api($url.monitoring.journey.file.edit, {
    uriParams: { ID: journeyId.value, ID_FILE: fileSelected.value._id },
    body: formEdit.value
  })
    .then((response: any) => {
      const { data, success, errors } = response.data?.value || {}

      if (success) {
        process.client && $toast().success($t('labels.editSuccess'))
        refresh()
        showModalEdit.value = false
      }

      loadingEdit.value = false
    })
    .catch(() => {
      loadingEdit.value = false
    })
}

const handleDeleteFile = () => {
  loadingDelete.value = true
  $api($url.monitoring.journey.file.delete, {
    uriParams: { ID: journeyId.value, ID_FILE: fileSelected.value._id },
    body: formEdit.value
  })
    .then((response: any) => {
      const { data, success, errors } = response.data?.value || {}

      if (success) {
        process.client && $toast().success($t('labels.deleteSuccess'))
        refresh()
        showModalDelete.value = false
      }
      loadingDelete.value = false
    })
    .catch(() => {
      loadingDelete.value = false
    })
}

onMounted(() => {
  getFiles()
})

const refresh = $lodash.debounce(getFiles, 500)

defineExpose({ refresh })
</script>
